import NewsModelOne from "./models/newsModelOne";
import NewsModelThree from "./models/newsModelThree";
import NewsModelTwo from "./models/newsModelTwo";

const NewsTemplate = (route) => {
  return route.model === 1 ? (
    <NewsModelOne {...route} />
  ) : route.model === 2 ? (
    <NewsModelTwo {...route} />
  ) : (
    <NewsModelThree {...route} />
  );
};

export default NewsTemplate;
